<template>
  <form class="c-searchform" @submit.prevent="submit" :class="{'is-searching':loading}">
    <button type="submit" class="c-searchform__submit"/>
    <input type="search" @focus="getFocus" ref="input" class="c-searchform__input" :placeholder="$t('search.input')" v-model="query"/>
    <button class="c-searchform__reset" @click.prevent="stop" v-if="query.length || (is_mobile&&focus)"/>
    <button class="c-searchform__vocal" :class="{'is-active':recognizing}" @click.prevent="toggleRecognition" v-if="recognizer"/>
  </form>
</template>

<script>

import {search} from "@/scripts/api";
import Bugsnag from "@bugsnag/js";

export default {
  data() {
    return {
      searching: false,
      autocomplete_timeout: false,
      recognizer: false,
      recognizing: false,
      focus: false,
      transcription: '',
      hold: false
    }
  },
  computed:{
    loading(){
      return this.$store.state.loading;
    },
    is_mobile(){
      return window.innerWidth<1024
    },
    query: {
      get () {
        return this.$store.state.query
      },
      set (value) {
        this.$store.commit('query', value)
      }
    },
    search_results(){
      return this.$store.state.search_results
    }
  },
  watch:{
    query(){
      clearTimeout(this.autocomplete_timeout)
      this.autocomplete_timeout = setTimeout(this.searchAutocomplete,300)
    }
  },
  methods:{
    searchAutocomplete(){

      clearTimeout(this.autocomplete_timeout)
      this.searching = true

      this.$store.commit('loading', true);

      this.$nextTick(()=>{

        search(this.query, 5).then((search_results)=>{

          this.$store.commit('search_results', search_results);

          if( this.hold )
            this.search(search_results)
        });
      })
    },
    getFocus(){

      this.focus = true
      this.$emit('input-focus', true)
      this.$store.commit('searching', false)

      this.$router.push({ name: 'home'})
    },
    setFocus(){

      if( this.$refs.input )
        this.$refs.input.focus()
    },
    loseFocus(){

      if( this.$refs.input )
        this.$refs.input.blur()

      this.focus = false
      this.query = ''

      this.$emit('input-focus', false)
    },
    submit(){

      if( !this.searching ){

        this.hold = true
        this.searchAutocomplete()
      }
      else if( !this.loading ){

        this.search(this.search_results)
      }
      else{

        this.hold = true
      }
    },
    search(search_results){

      this.hold = false

      if( this.query.length < 3 || !search_results )
        return;

      if( search_results.addresses && search_results.addresses.length ){

        const address = search_results.addresses[0];

        this.$store.commit('recent_search', address)
        this.$store.commit('position', address.latLng);

        if( address.type === 'municipality' )
          this.emitter.emit('goTo', {latLng:address.latLng, zoom:13})
        else
          this.emitter.emit('goTo', {latLng:address.latLng, zoom:14})
      }
      else if( search_results.stores.length ){

        const address = search_results.stores[0];
        this.$router.push({ name: 'store', params: { id: address.id } })
      }

      this.reset()
    },
    initSpeechRecognition(){

      const speechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition

      if( !speechRecognition )
        return;

      this.recognizer = new speechRecognition();

      this.recognizer.addEventListener('result', this.getResult);
      this.recognizer.addEventListener('error', this.stopRecognition);
      this.recognizer.addEventListener('end', this.stopRecognition);
    },
    getResult(event){

      let transcription = '';

      for (let i = event.resultIndex, len = event.results.length; i < len; i++)
        transcription += event.results[i][0].transcript;

      if( transcription.length ){

        this.query = transcription;
        this.getFocus();
      }
    },
    toggleRecognition(){

      if( this.recognizing )
        this.stopRecognition()
      else
        this.startRecognition()
    },
    startRecognition(){

      try {

        this.recognizing = true;
        this.recognizer.start();

      } catch (error) {

        Bugsnag.notify(new Error(error))
        this.recognizing = false;
      }
    },
    stopRecognition(){

      this.recognizing = false;
      this.recognizer.stop();
    },
    stop(){

      this.reset()
      this.$emit('input-focus', false)

      this.$router.push({ name: 'home'})
    },
    reset(){

      this.loseFocus()

      this.$store.commit('searching', false)
    }
  },
  mounted() {

    this.initSpeechRecognition()

    this.emitter.on('searchFocus', this.setFocus)

    if( this.query )
      this.setFocus()
  },
  beforeUnmount() {

    this.emitter.off('searchFocus', this.setFocus)

    if( this.recognizer ){

      this.recognizer.removeEventListener('result', this.getResult);
      this.recognizer.removeEventListener('error', this.stopRecognition);
      this.recognizer.removeEventListener('end', this.stopRecognition);
    }
  }
}
</script>

<style lang="scss">
.c-searchform{
  height: 100%; background: $c-white; border-radius: $radius; display: flex; position: relative; z-index: 2;
  padding: 0 $space-s; pointer-events: all;
  @media #{$to-phone} {
    height: 5rem;
  }
  &__input{ height: 100%; border: 0; flex-grow: 1; background: none }
  &__submit{
    background: url("../assets/picto/magnifier.svg") no-repeat center; background-size: 50%; aspect-ratio: 1;
    height: 100%;
    @media #{$to-phone} { height: 80%; top: 10%; position: relative }
  }
  &__reset{
    background: url("../assets/picto/close.svg") no-repeat center; background-size: 50%; aspect-ratio: 1;
    height: 100%; cursor: pointer; position: relative;
    .is-searching &{ background-image: url("../assets/picto/loader.svg"); pointer-events: none }
  }
  &__vocal{
    background: url("../assets/picto/microphone.svg") no-repeat center; background-size: 50%; aspect-ratio: 1;
    height: 100%; cursor: pointer; position: relative;
    .is-searching &{ background-image: url("../assets/picto/loader.svg"); pointer-events: none }
    &.is-active{
      background: none; animation: pulse 3s $ease-in-out-quad infinite;
      &:after{
        content: ''; background: #cc0000; width: 1rem; height: 1rem; position: absolute;
        left: 50%; top: 50%; margin-left: -0.5rem; margin-top: -0.5rem; border-radius: 50%;
      }
      &:before{
        content: ''; outline: 1px solid #cc0000; outline-offset: 3px; width: 1rem; height: 1rem; position: absolute;
        left: 50%; top: 50%; margin-left: -0.5rem; margin-top: -0.5rem; border-radius: 50%;
      }
    }
  }
  &__reset+ &__vocal{ display: none }
}

@keyframes pulse {
  0%{ opacity: 1 }
  50%{ opacity: 0.3 }
  100%{ opacity: 1 }
}
</style>
